__turbopack_context__.v({
  "cellContent": "dataTable-module-scss-module__kt0D-W__cellContent",
  "dataTableWrapper": "dataTable-module-scss-module__kt0D-W__dataTableWrapper",
  "error-msg": "dataTable-module-scss-module__kt0D-W__error-msg",
  "errorIcon": "dataTable-module-scss-module__kt0D-W__errorIcon",
  "evenRow": "dataTable-module-scss-module__kt0D-W__evenRow",
  "headerContent": "dataTable-module-scss-module__kt0D-W__headerContent",
  "hint": "dataTable-module-scss-module__kt0D-W__hint",
  "noResults": "dataTable-module-scss-module__kt0D-W__noResults",
  "selectedCell": "dataTable-module-scss-module__kt0D-W__selectedCell",
  "selectedHeader": "dataTable-module-scss-module__kt0D-W__selectedHeader",
  "selectedRow": "dataTable-module-scss-module__kt0D-W__selectedRow",
  "sortButton": "dataTable-module-scss-module__kt0D-W__sortButton",
  "sortIcon": "dataTable-module-scss-module__kt0D-W__sortIcon",
  "spinner": "dataTable-module-scss-module__kt0D-W__spinner",
  "spinnerContainer": "dataTable-module-scss-module__kt0D-W__spinnerContainer",
  "tableCell": "dataTable-module-scss-module__kt0D-W__tableCell",
  "tableContainer": "dataTable-module-scss-module__kt0D-W__tableContainer",
  "tableHead": "dataTable-module-scss-module__kt0D-W__tableHead",
});
